import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import LazyLoad, { forceCheck } from 'react-lazyload';
import st from './styles.module.scss';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import GetProposal from '../../components/proposal/ppc/GetProposal';
import Pricing from '../../components/video-production/Pricing';
import ViewMore from '../../components/ViewMore';

const FinancialProblems = dynamic(() => import('../../components/financial/FinancialProblems'), {
  suspense: true,
});
const SolveProblems = dynamic(() => import('../../components/financial/SolveProblems'), {
  suspense: true,
});

const Financial = props => {
  useEffect(() => {
    forceCheck();
  }, []);
  const [showModalPPC, setShowModalPPC] = useState(false);
  const [showPricingModalState, setShowPricingModalState] = useState(false);

  const setHidden = () => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  };
  const hideOfferModalPPC = () => {
    setShowModalPPC(false);
    if (document.getElementById('form-ppc')) document.getElementById('form-ppc').reset();
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing?type=financial';
    } else {
      // document.getElementById('pricing-form').reset();
      setShowPricingModalState(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalState(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  return (
    <>
      <Head>
        <title>Video Production - Financial Videos | Prodigi</title>
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta
          name="description"
          content="Prodigi offers video production services in Armenia for financial companies. Increase engagement and grow your client base with effective video solutions."
        />
        <meta property="og:url" content="https://weprodigi.com/financial" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Financial Videos | Prodigi" />
        <meta
          property="og:description"
          content="Prodigi offers video production services in Armenia for financial companies. Increase engagement and grow your client base with effective video solutions."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/financial/meta.jpg" />
      </Head>
      <div className="main">
        <div className={`relative w-full  h-intro  overflow-hidden   `}>
          <video
            width="100%"
            height="100%"
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            id="header-11"
            className={'absolute h-intro md:h-full ' + st['header-mp4']}
          >
            <source src="https://weprodigi.com/uploads/images/financial/Financial.mp4" type="video/mp4" />
          </video>
          <div className="container h-full">
            <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
              <h1 className="capitalize text-white text-30 md:text-60  font-bolder leading-none">
                Videos for
                <span className="block leading-[45px] md:leading-none mt-10 md:mt-20">Financial Industry</span>
              </h1>

              <div onClick={showPricingModal} className={'cursor-pointer icon-green mt-23 md:mt-0'}>
                <style>{`
                                    .icon-green .icon-calculator-container .icon-calculator {
                                        filter: brightness(0) invert(1) !important;
                                    }
                                     .card-rounded{
                                          border-radius: 20px 20px 20px 20px;
                                        }
                                        .bg-review{
                                          background-size:cover!important;
                                         background-position: bottom!important;
                                         height:320px;
                                       }
                                          @media screen and (max-width:768px){
                                             .bg-review{
                                               /*// background:unset;*/
                                               height:unset;
                                             }
                                         }
                                `}</style>
                <a className="calculate-price-header relative z-10  md:inline-block border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-5 bg-green-badge hover:bg-green-hover hover:text-white transition-all icon-calculator-container transition-400">
                  <span className="icon icon-calculator" />
                  Get Pricing
                </a>
              </div>
            </div>
          </div>
        </div>

        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container flex flex-wrap md:flex-nowrap justify-between">
              <div className="w-full md:w-half-auto hidden md:block">
                <img src="https://weprodigi.com/uploads/images/healthcare/healthcare2_21.jpg" width={'100%'} height={100} alt="we rock digital" />
              </div>
              <div className="w-full md:w-half-auto mt-18 md:mt-0  hidden md:block">
                The financial industry can be challenging when it comes to explaining complex topics and promoting services to potential customers.
                Many people view finance as boring and may be intimidated by lengthy paperwork and brochures. In such a competitive field, it can be
                difficult for financial companies to attract and retain clients. While having a website is significant, it may not be enough to stand
                out from the competition. One way to differentiate your company is through engaging videos, which can effectively communicate
                financial concepts and services in an engaging and easily understandable way.
              </div>
              <div className="w-full md:w-half-auto mt-18 md:mt-0  block md:hidden">
                <ViewMore ln={40}>
                  The financial industry can be challenging when it comes to explaining complex topics and promoting services to potential customers.
                  Many people view finance as boring and may be intimidated by lengthy paperwork and brochures. In such a competitive field, it can be
                  difficult for financial companies to attract and retain clients. While having a website is significant, it may not be enough to
                  stand out from the competition. One way to differentiate your company is through engaging videos, which can effectively communicate
                  financial concepts and services in an engaging and easily understandable way.
                </ViewMore>
              </div>
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={200} once>
          <div className={'bg-gray-white py-24'}>
            <div className="container">
              {/*<video  controls className="float-right pl-0 md:pl-20 pb-10 w-full md:w-half-auto hidden md:block" poster={"https://weprodigi.com/uploads/images/healthcare/poster_4.jpg"}>*/}
              {/*   <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback4.mp4" type="video/mp4"/>*/}
              {/*</video>*/}
              <div>
                <h2 className={'w-full  font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                  The Importance of Video for financial companies
                </h2>
                {/*<video  controls className="float-right pl-0 md:pl-20 pb-10 w-full md:w-half-auto block md:hidden mt-23 mb-10" poster={"https://weprodigi.com/uploads/images/healthcare/poster_4.jpg"}>*/}
                {/*    <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback4.mp4" type="video/mp4"/>*/}
                {/*</video>*/}
                <p className={'mt-20  block'}>
                  The use of video in the financial industry can have numerous benefits for companies looking to promote their products and services
                  and connect with potential customers. Engagement is often higher with video compared to text or images alone, making it an effective
                  way to capture viewers' attention.{' '}
                  <a href="https://wyzowl.s3.eu-west-2.amazonaws.com/pdfs/Wyzowl-Video-Survey-2022.pdf" className={''} target={'_blank'}>
                    94% of marketers
                  </a>{' '}
                  prove video helps increase customer understanding of products and services. Moreover, the best-performing video types are explainer
                  videos (74%). Here are a few more reasons why video is important for financial companies:
                </p>
                <div className={'list-decimal list-inside'}>
                  <div className={st.marker}>
                    <span className={'mr-10'}>1.</span>
                    <div>
                      <span className={'font-bolder'}>Improves engagement:</span>
                      Gives a better understanding of financial processes and products, increases interest and engagement, and provides a unique way
                      to share thoughts and experiences about investments, mobile banking, or any other fintech innovation on social platforms.
                    </div>
                  </div>
                  <div className={st.marker}>
                    <span className={'mr-10'}>2.</span>
                    <div>
                      <span className={'font-bolder'}>Makes complex concepts easier to understand:</span>
                      Financial concepts and products can be complex, and video can help explain them in a way that is easy for viewers to understand.
                      For example, a fintech company specializing in mobile banking applications could create a series of explainer videos that show
                      customers how to use the app's various features, such as how to set up account alerts, pay bills, and deposit checks.
                    </div>
                  </div>
                  <div className={st.marker}>
                    <span className={'mr-10'}>3.</span>
                    <div>
                      <span className={'font-bolder'}>Increases conversions:</span>
                      Including video on a landing page can increase conversions for your financial product by as much as 80%.
                    </div>
                  </div>
                  <div className={st.marker}>
                    <span className={'mr-10'}>4.</span>
                    <div>
                      <span className={'font-bolder'}>Improves SEO:</span>
                      Google and other search engines often give higher rankings to websites that include video, which can help improve your company's
                      search engine optimization (SEO).
                    </div>
                  </div>
                  <div className={st.marker}>
                    <span className={'mr-10'}>5.</span>
                    <div>
                      <span className={'font-bolder'}>Increases brand awareness: </span>
                      Video can help increase brand awareness and establish trust with potential customers.
                    </div>
                  </div>
                </div>
                {/*<div className={'mt-20 block md:hidden'}>*/}
                {/*    <ViewMore ln={40}>*/}
                {/*        The Importance of Video for financial companies*/}

                {/*    </ViewMore>*/}
                {/*</div>*/}
              </div>
              <br className={'clear-both hidden'} />
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container">
              <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                What video types are used for financial companies?
              </h2>
              <p className={'mt-20'}>
                Before creating video content, it's important to carefully plan and define your goals and objectives. These goals should be aligned
                with your overall business objectives. By setting clear goals and objectives, you can now proceed to choose a type of video for
                fintech.
              </p>

              <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <video width="540" controls className="w-full">
                    <source src="https://weprodigi.com/uploads/images/financial/Apaprika_Finance_2DAnimationbyProDigi.mp4" type="video/mp4" />
                  </video>
                  <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Apaprika | 2D Explainer Animation</p>
                </div>

                <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                  <h3 className="text-purple font-bold text-24   leading-none">Explainer Videos</h3>
                  <div className={'mt-16 hidden md:block'}>
                    <ViewMore ln={80}>
                      Explainer videos can be an effective marketing tool for the financial industry to boost customer engagement and loyalty. Whether
                      it is an animated video, talking-head video, or text overlay video, the impact will be incomparably higher than any other type
                      of ad format. Some ideas for using explainer videos in the financial industry include: 1) Informing about financial institution
                      policies: The simple nature of explainer videos is an effective way to keep customers updated with fast-changing industry news
                      and policies. 2) Explaining financial products or services and terms: Use explainer videos to demonstrate the features and
                      benefits of your financial products or services, educate customers, and present industry-specific terminology. 3)Describing
                      financial concepts: Use explainer videos to break down complex financial concepts and make them straightforward for a wider
                      audience. 4) Showcasing case studies: Use explainer videos to share real-life examples of how your financial products or
                      services have helped customers. 5)Providing tutorials: Use explainer videos to create tutorials that show viewers how to use
                      your financial products or services.
                    </ViewMore>
                  </div>
                  <div className={'mt-16 block md:hidden'}>
                    <ViewMore ln={40}>
                      Explainer videos can be an effective marketing tool for the financial industry to boost customer engagement and loyalty. Whether
                      it is an animated video, talking-head video, or text overlay video, the impact will be incomparably higher than any other type
                      of ad format. Some ideas for using explainer videos in the financial industry include: 1) Informing about financial institution
                      policies: The simple nature of explainer videos is an effective way to keep customers updated with fast-changing industry news
                      and policies. 2) Explaining financial products or services and terms: Use explainer videos to demonstrate the features and
                      benefits of your financial products or services, educate customers, and present industry-specific terminology. 3)Describing
                      financial concepts: Use explainer videos to break down complex financial concepts and make them straightforward for a wider
                      audience. 4) Showcasing case studies: Use explainer videos to share real-life examples of how your financial products or
                      services have helped customers. 5)Providing tutorials: Use explainer videos to create tutorials that show viewers how to use
                      your financial products or services.
                    </ViewMore>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <h3 className="text-purple font-bold text-24 leading-none">Product Videos</h3>
                  <p className={'mt-16'}></p>

                  <div className={'mt-16 hidden md:block'}>
                    <ViewMore ln={80}>
                      Promo videos are short videos that showcase product or service features and benefits. In the financial industry, a promo video
                      is used to better navigate leads through the services and work on increasing conversion at the top of the sales funnel. 1)
                      Highlighting the benefits of financial products or services: Use promo videos to clearly and concisely describe the benefits of
                      your financial products or services. 2) Encouraging sign-ups or purchases: Use promo videos to encourage viewers to sign up for
                      or purchase your financial products or services. 3) Building trust: Use promo videos to establish trust with potential customers
                      by highlighting the value and reliability of your financial products or services. 4) Solving problems: Use promo videos to
                      demonstrate to viewers how your products or services can solve their problems or meet their needs.
                    </ViewMore>
                  </div>
                  <div className={'mt-16 block md:hidden'}>
                    <ViewMore ln={40}>
                      Promo videos are short videos that showcase product or service features and benefits. In the financial industry, a promo video
                      is used to better navigate leads through the services and work on increasing conversion at the top of the sales funnel. 1)
                      Highlighting the benefits of financial products or services: Use promo videos to clearly and concisely describe the benefits of
                      your financial products or services. 2) Encouraging sign-ups or purchases: Use promo videos to encourage viewers to sign up for
                      or purchase your financial products or services. 3) Building trust: Use promo videos to establish trust with potential customers
                      by highlighting the value and reliability of your financial products or services. 4) Solving problems: Use promo videos to
                      demonstrate to viewers how your products or services can solve their problems or meet their needs.
                    </ViewMore>
                  </div>
                </div>
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <video width="540" controls className="w-full  ">
                    <source src="https://weprodigi.com/uploads/images/financial/StatusCards_Finance_3DProductVideobyProDigi.mp4" type="video/mp4" />
                  </video>
                  <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Card | 3D Product Video</p>
                </div>
              </div>
              <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <video width="540" controls className="w-full" poster={'https://weprodigi.com/uploads/images/financial/poster3.jpg'}>
                    <source src="https://weprodigi.com/uploads/images/financial/LaneHealth_Finance_Whiteboardanimation.mp4" type="video/mp4" />
                  </video>
                  <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Lane Health | Whiteboard Animation</p>
                </div>

                <div className={'w-full md:w-half-auto '}>
                  <h3 className="text-purple font-bold text-24 leading-none">Videos for Internal Communication</h3>
                  <div className={'mt-16 hidden md:block'}>
                    <ViewMore ln={'80'}>
                      A video is a powerful tool not only for engaging with customers but for establishing a robust and professional communication
                      culture within the organization. Here are a few ways that financial companies can use video for internal communication: 1)
                      Training and onboarding: Use video to train new employees and onboard them to your company and its policies and procedures. 2)
                      Company updates: Use video to share company updates and important information with employees. 3) Team building and
                      collaboration: Use video to facilitate team building and collaboration among employees, especially if your company has a
                      distributed workforce. 4) Executive communication: Use video to share messages from executives and leadership with employees. 5)
                      Employee recognition: Use video to recognize and reward employees for their achievements and contributions to the company.
                    </ViewMore>
                  </div>

                  <div className={'mt-16 block md:hidden'}>
                    <ViewMore ln={'40'}>
                      A video is a powerful tool not only for engaging with customers but for establishing a robust and professional communication
                      culture within the organization. Here are a few ways that financial companies can use video for internal communication: 1)
                      Training and onboarding: Use video to train new employees and onboard them to your company and its policies and procedures. 2)
                      Company updates: Use video to share company updates and important information with employees. 3) Team building and
                      collaboration: Use video to facilitate team building and collaboration among employees, especially if your company has a
                      distributed workforce. 4) Executive communication: Use video to share messages from executives and leadership with employees. 5)
                      Employee recognition: Use video to recognize and reward employees for their achievements and contributions to the company.
                    </ViewMore>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={200} once>
          <div className={'bg-gray-light py-24'}>
            <div className="container">
              <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                {' '}
                What are the problems of the financial industry?
              </h2>
              <p className={'mt-20'}>
                The healthcare and pharmaceutical industries deal with complexity on many levels - from processes and procedures to innovations and
                breakthroughs that could save lives. Being clear and sensitive is more crucial than ever. Three significant problems acted as
                pressures for integrating innovations into healthcare.
              </p>
              <Suspense fallback={`Loading...`}>
                <FinancialProblems />
              </Suspense>
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container">
              <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                How can video production solve these problems?
              </h2>
              <p className={'mt-20'}>Here are some ways that videos can help:</p>
              <Suspense fallback={`Loading...`}>
                <SolveProblems />
              </Suspense>
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={0} once>
          <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
            <div id="stars" />
            <div id="stars2" />
            <div id="stars3" />
            <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
              <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
                CALCULATE YOUR Financial VIDEO COST <br />
                <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                  Answer five questions and get to know the price!
                </span>
                <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                  <button
                    className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                    onClick={showPricingModal}
                  >
                    Start Now
                  </button>
                </div>
              </div>
              <img src="https://weprodigi.com/uploads/images/healthcare/Eva1.webp" alt="eva" />
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={200} once>
          <div className={'bg-gray-white py-24'}>
            <div className="container">
              <h2 className={'w-full md:w-70p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                {' '}
                How to Choose the Right Video Production Agency for your video?
              </h2>
              <p className="mt-24">
                {' '}
                Video will be a productive marketing technique if only it is implemented professionally. Today, the market offers infinite templates
                and video production agencies, and navigating through this variety can be more than frustrating. Your choice should be based on
                specific requirements to achieve the desired results and turn video into a competitive advantage.{' '}
              </p>
              <div className="mt-24 flex flex-wrap   justify-between items-start ">
                <div className={'w-full md:w-half-auto flex items-start'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10">
                    <b> Determine your goals: </b>Before you start looking for a video production agency, it's important to have a clear idea of what
                    you want to achieve with your video. Do you want to increase brand awareness, explain a complex concept, or drive sales? Having
                    clear goals will help you find an agency that is well-suited to your needs.
                  </p>
                </div>
                <div className={'w-full md:w-half-auto flex  items-start'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10">
                    <b>Research potential agencies:</b> Search for video production companies with a proven record of success in making fintech
                    videos. Examine their portfolio to make sure their style and approach match your desired aesthetic.
                  </p>
                </div>
                <div className={'w-full md:w-half-auto flex  items-start mt-16'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="pl-10">
                    <b> Consider their process: </b>Find out how the agency works, from initial concept development to final delivery. Make sure their
                    process is transparent. Professional video production agencies will clearly communicate the stages of video production. This will
                    include
                    <ul className={st.ul}>
                      <li>Discovery</li>
                      <li>Script and storyboard sketching</li>
                      <li>Voiceover</li>
                      <li>Graphic illustration</li>
                      <li>Animation</li>
                      <li>Final delivery</li>
                    </ul>
                  </div>
                </div>

                <div className={'w-full md:w-half-auto flex flex-col justify-start items-start mt-16'}>
                  <div className={'w-full  flex justify-start items-start mt-0'}>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <p className="pl-10">
                      <b>Look for a good fit: </b>Finding an agency that you trust and feel comfortable working with is an absolute must. Make sure to
                      find an agency that is attentive, communicative, and open to your suggestions.
                    </p>
                  </div>
                  <div className={'w-full  flex justify-start items-start mt-16'}>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <p className="pl-10">
                      <b>Get references:</b> Ask the agency for references or case studies from previous clients. This will give you an idea of their
                      work and help you gauge whether they are a good fit for your project.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>

        {/*<LazyLoad height={200}  once>*/}
        {/*    <div className={'bg-white py-24'}>*/}
        {/*        <div className="container">*/}
        {/*            <div className="flex flex-wrap md:flex-nowrap justify-between">*/}
        {/*                <div className="w-full md:w-half-auto">*/}
        {/*                    <h2 className={'font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>How to Choose the Right Video Production Agency for your Healthcare video?</h2>*/}
        {/*                    <p className="mt-16">*/}
        {/*                        Short, engaging videos with creative animation will be more effective than hours of presentation filled with hard-to-understand terminology. The biggest challenge of creating a captivating professional video is the expertise of the video production agency you have turned to. There are, if not thousands, then hundreds of video production agencies in your country or abroad offering services. But how to find the one that will meet your objectives and be experienced enough to deliver quality? Here are some tips to consider:*/}
        {/*                    </p>*/}
        {/*                </div>*/}
        {/*                <div className="w-full md:w-half-auto mt-10 md:mt-0">*/}
        {/*                    <div className="rounded-5 bg-red-headerInner py-10 px-17">*/}
        {/*                        <svg xmlns="http://www.w3.org/2000/svg" width={15} className="pt-5 float-left" fill="none" viewBox="0 0 24 24" stroke="#670F7A" strokeWidth={3}>*/}
        {/*                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />*/}
        {/*                        </svg>*/}
        {/*                        When researching video production agencies, ensure the shortlisted ones have relevant background and experience in the industry, understand the healthcare needs to the core, and possess up-to-date tools to create a professional video*/}
        {/*                    </div>*/}
        {/*                    <div className="rounded-5 bg-red-headerInner py-10 px-17 mt-16 ">*/}
        {/*                        <svg xmlns="http://www.w3.org/2000/svg" width={15} className="pt-5 float-left" fill="none" viewBox="0 0 24 24" stroke="#670F7A" strokeWidth={3}>*/}
        {/*                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />*/}
        {/*                        </svg>*/}
        {/*                        Find out whether the agency has a professional script writer or not. The video script is one of the most significant details to take care of. The final video will be obscure and unappealing if the scriptwriter is not professional enough.*/}
        {/*                    </div>*/}
        {/*                    <div className="rounded-5 bg-red-headerInner py-10 px-17 mt-16  ">*/}
        {/*                        <svg xmlns="http://www.w3.org/2000/svg" width={15} className="pt-5 float-left" fill="none" viewBox="0 0 24 24" stroke="#670F7A" strokeWidth={3}>*/}
        {/*                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />*/}
        {/*                        </svg>*/}
        {/*                        Make sure the agency you have chosen doesn’t use templates for videos. The modern market is flooded with videos built on templates; they look similar and generate absolutely no impression. To make your video unique, it should have custom details visualizing your brand identity, so your target audience remembers you.*/}
        {/*                    </div>*/}
        {/*                </div>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</LazyLoad>*/}
        <LazyLoad once height={300}>
          <div className={` scale-y-1  height-transition `}>
            <div className={'bg-review  mt-20 md:mt-0 ' + st['review-3']}>
              <div className={'container mt-0 md:mt-0 h-full flex flex-wrap md:flex-nowrap justify-between items-center pb-30 md:pb-0'}>
                <div className={'w-full md:w-auto mt-0 md:mt-0  py-24'}>
                  <p className={'text-white md:text-white text-20 md:text-32 leading-24 md:leading-39 font-400 max-w-650'}>
                    We've driven <span className={'text-green font-bolder'}>86,300,000 video views</span> for our clients through video production
                    services.
                  </p>
                  <p className="text-white md:text-white font-normal-700 text-20 md:text-32 leading-24 md:leading-39">
                    Discover how we can help your business
                  </p>
                  {/*<button className={'w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5'}>Send me a proposal</button>*/}
                  <div className={'w-full hidden md:flex'}>
                    <a
                      href={'https://weprodigi.com/video-production'}
                      className="text-center capitalize hover:bg-purple-overlay  block w-full md:w-auto mt-24 text-white bg-purple rounded-5 px-23 py-5"
                    >
                      see full service
                    </a>
                    <a
                      className="hidden ml-20  hover:bg-green-hover md:block w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5"
                      href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                      target={'_blank'}
                    >
                      {' '}
                      Schedule a Call
                    </a>
                    <a
                      className="block  hover:bg-green-hover md:hidden text-center w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5"
                      href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                      target={'_blank'}
                    >
                      {' '}
                      Schedule a Call
                    </a>
                  </div>
                </div>
                <div className={'w-full md:w-auto  md:block pl-0 md:pl-40'}>
                  <p className="text-white font-normal-700 text-18 md:text-18 leading-28 mb-10 md:mb-0 md:leading-39">
                    What our video production clients say
                  </p>
                  <div className="bg-white shadow-lg min-h-280 md:min-h-250   card-rounded py-25 px-14 flex justify-start items-start relative">
                    <img
                      src="https://weprodigi.com/uploads/images/home-page/Formatquote.svg"
                      className={'-mt-12'}
                      width={55}
                      height={55}
                      alt="format quote"
                    />
                    <div className={'relative max-w-320'}>
                      <p className={'text-16 text-black leading-20 font-400'}>
                        Their creativity and passion for the project is impressive. Their ability to work to tight schedules and meet deadlines. Their
                        ability to think outside the box especially during the COVID-19 restrictions .
                      </p>
                      <p className={'text-purple text-16 leading-20 font-bolder mt-16'}>Johnson Samuyiwa, Director </p>
                      <p className="text-black  text-16 leading-20  mt-8">SelectTVFormats LTD</p>
                    </div>
                    <a
                      aria-label={'view more'}
                      href="https://clutch.co/profile/weprodigi-agency?page=3&project_cost=&review_type=&service_provided=&sort_by=date_DESC#review-1651937"
                      target={'_blank'}
                      className={'text-purple text16 font-bolder flex items-center absolute bottom-15 hover-arrow right-30'}
                    >
                      More
                      <svg xmlns="http://www.w3.org/2000/svg" width={18} viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                  <div className={'w-full flex md:hidden'}>
                    <a
                      href={'https://weprodigi.com/video-production'}
                      target={'_blank'}
                      className="text-center text-16 capitalize hover:bg-purple-overlay  block w-full md:w-auto mt-24 text-white bg-purple rounded-5  px-0 md:px-23 py-5"
                    >
                      see full service
                    </a>
                    <a
                      className="block  md:hidden text-center text-16 w-full md:w-auto mt-24 ml-20 text-white bg-green hover:bg-green-hover rounded-5 px-none md:px-23 py-5"
                      href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                      target={'_blank'}
                    >
                      Get Pricing
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
      </div>

      <GetProposal
        from={'contact'}
        country={props.country}
        show={showModalPPC}
        id={'form-ppc'}
        hide={hideOfferModalPPC}
        website={''}
        currency={props.currency}
      />
      <Pricing from="healthcare" videoLength={[]} script={''} country={props.country} show={showPricingModalState} hide={hidePricingModal} step={1} />
    </>
  );
};

export default Financial;
